import {useState, useCallback} from 'react'
import type {SelectedAgent} from '../types/session'
import {useLocalStorageCache} from './useLocalStorageCache'

const LAST_SELECTED_AGENT_KEY = 'AGENT_SESSIONS_LAST_SELECTED_AGENT'

/**
 * Hook to manage the last selected agent with local storage persistence.
 *
 * Priority: preselectedAgent (from picker) > localStorage cache > Copilot default (empty object)
 */
export function useLastSelectedAgent(
  preselectedAgent?: SelectedAgent,
): [SelectedAgent, (agent: SelectedAgent) => void] {
  const {value: cachedAgent, setValue: persistToStorage} = useLocalStorageCache<SelectedAgent>(LAST_SELECTED_AGENT_KEY)

  const [selectedAgentState, setSelectedAgentState] = useState<SelectedAgent>(() =>
    preselectedAgent?.typeName ? preselectedAgent : (cachedAgent ?? {}),
  )

  const setSelectedAgent = useCallback(
    (agent: SelectedAgent) => {
      setSelectedAgentState(agent)
      persistToStorage(agent)
    },
    [persistToStorage],
  )

  return [selectedAgentState, setSelectedAgent]
}
